// Vue
import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import { AppModule } from './modules/app';
import { CustomerModule } from './modules/customer';
import { ReviewModule } from './modules/review';
import { SettingsModule } from './modules/settings';
import { SupplierModule } from './modules/supplier';
import { SurveyModule } from './modules/survey';
import { UserModule } from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store<any>({
  modules: {
    // !!TODO Add new store modules in alphabetical order
    app: AppModule,
    customers: CustomerModule,
    reviews: ReviewModule,
    settings: SettingsModule,
    suppliers: SupplierModule,
    surveys: SurveyModule,
    users: UserModule,
  },
});

export default store;
